import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from '../assets/min-main-logo.png';
import _imports_1 from '../assets/GPS.png';
var _hoisted_1 = { class: "find-scenic-food" };
var _hoisted_2 = { class: "back-button" };
var _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "home-logo" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_0,
        alt: ""
    })
], -1);
var _hoisted_4 = { class: "scenic-food-info-container" };
var _hoisted_5 = { class: "cards" };
var _hoisted_6 = /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_1,
    alt: ""
}, null, -1);
var _hoisted_7 = /*#__PURE__*/ _createElementVNode("p", null, "附近", -1);
var _hoisted_8 = [
    _hoisted_6,
    _hoisted_7
];
var _hoisted_9 = { class: "footer" };
var _hoisted_10 = ["src"];
var _hoisted_11 = /*#__PURE__*/ _createTextVNode(" 景點 ");
var _hoisted_12 = ["src"];
var _hoisted_13 = /*#__PURE__*/ _createTextVNode(" 美食 ");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_ArrowLeftBold = _resolveComponent("ArrowLeftBold");
    var _component_el_icon = _resolveComponent("el-icon");
    var _component_router_link = _resolveComponent("router-link");
    var _component_ScenicFoodInfoCard = _resolveComponent("ScenicFoodInfoCard");
    var _component_BaseLayout = _resolveComponent("BaseLayout");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_BaseLayout, null, {
            header: _withCtx(function () { return [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_el_icon, { onClick: _ctx.goBack }, {
                        default: _withCtx(function () { return [
                            _createVNode(_component_ArrowLeftBold)
                        ]; }),
                        _: 1
                    }, 8, ["onClick"])
                ]),
                _createVNode(_component_router_link, { to: "/" }, {
                    default: _withCtx(function () { return [
                        _hoisted_3
                    ]; }),
                    _: 1
                })
            ]; }),
            body: _withCtx(function () { return [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nearByTourismInfo, function (info) {
                            return (_openBlock(), _createBlock(_component_ScenicFoodInfoCard, {
                                key: info.ID,
                                tourisnInfo: info,
                                onClick: function ($event) { return (_ctx.getDetail(info)); }
                            }, null, 8, ["tourisnInfo", "onClick"]));
                        }), 128))
                    ])
                ]),
                _createElementVNode("div", {
                    class: "gps-search",
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        function () {
                            var args = [];
                            for (var _i = 0; _i < arguments.length; _i++) {
                                args[_i] = arguments[_i];
                            }
                            return (_ctx.getLocation && _ctx.getLocation.apply(_ctx, args));
                        })
                }, _hoisted_8)
            ]; }),
            footer: _withCtx(function () { return [
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["footer-button", { active: _ctx.searchType === 'Spot' }]),
                        onClick: _cache[1] || (_cache[1] = function ($event) { return (_ctx.searchType = 'Spot'); })
                    }, [
                        _createElementVNode("img", {
                            src: require("../assets/" + (_ctx.searchType === 'Spot' ? 'active' : 'inactive') + "-attraction.png"),
                            alt: ""
                        }, null, 8, _hoisted_10),
                        _hoisted_11
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["footer-button", { active: _ctx.searchType === 'Food' }]),
                        onClick: _cache[2] || (_cache[2] = function ($event) { return (_ctx.searchType = 'Food'); })
                    }, [
                        _createElementVNode("img", {
                            src: require("../assets/" + (_ctx.searchType === 'Food' ? 'active' : 'inactive') + "-food.png"),
                            alt: ""
                        }, null, 8, _hoisted_12),
                        _hoisted_13
                    ], 2)
                ])
            ]; }),
            _: 1
        })
    ]));
}
